<template>
  <div class="hw-page">
    <navigation />
    <section class="hw-legal-page">
      <article class="hw-article">
        <p class="hw-kicker">Legal</p>
        <h1>Política de Privacidade</h1>
        <p>A vossa privacidade é importante para nós. É política do nosso website respeitar a privacidade em relação a qualquer informação que possamos recolher enquanto operamos os nossos serviços. Pedimos dados pessoais apenas quando são realmente necessários para prestar um serviço. Fazemo-lo por meios justos e legais, com o vosso conhecimento e consentimento.</p>
        <p>Explicamos o motivo da recolha e o modo como a informação será usada. Conservamos os dados apenas pelo tempo necessário para prestar o serviço pedido. Quando os armazenamos, protegemos por meios comercialmente adequados contra perda, roubo e acesso, divulgação, cópia, uso ou alteração não autorizados.</p>
        <p>Não partilhamos informações de identificação pessoal publicamente nem com terceiros, exceto quando a lei o exigir.</p>
        <p>O nosso website pode conter ligações para sítios externos que não são operados por nós. Não temos controlo sobre o conteúdo e as práticas desses sítios e não podemos aceitar responsabilidade pelas respetivas políticas de privacidade.</p>
        <p>São livres de recusar o nosso pedido de dados pessoais, com o entendimento de que talvez não possamos prestar alguns dos serviços pretendidos.</p>
        <p>A utilização continuada dos nossos serviços será considerada como aceitação das nossas práticas em matéria de privacidade e dados pessoais. Se tiverem alguma dúvida sobre o tratamento de dados do utilizador, contactem-nos.</p>
        <p>Esta política está em vigor a partir de 1 de setembro de 2022.</p>
        <button class="hw-btn hw-btn-ghost" type="button" @click="$router.push('/')">Voltar ao início</button>
      </article>
    </section>
    <bottom />
  </div>
</template>

<script>
import navigation from "../components/Navigation";
import bottom from "../components/Footer";

export default {
  name: "PrivacyPolicy",
  components: {
    navigation,
    bottom,
  },
};
</script>
